import React from 'react';
import {connect} from 'react-redux';
import logging from '@wr/logging';
import GenericErrorMessage from './molecules/GenericErrorMessage';
import {genericErrorHasOccurred} from '../actions/generic-error/action-creators';
import config from '../config';

const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);

class ErrorBoundary extends React.Component {
    state = {hasError: false}

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        this.props.dispatch(genericErrorHasOccurred(true));
        logger.error(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <GenericErrorMessage />;
        }

        return this.props.children;
    }
}

export default connect()(ErrorBoundary);
